import React from 'react';
import { formatDate } from '@/utils/dates';

type EntityDateProps = {
  dateString: string;
  entityId: string;
};

export default function EntityDate({ dateString, entityId }: EntityDateProps) {
  return (
    <span data-testid={`entity-details-summary-date-${entityId}`}>
      {formatDate(dateString)}
    </span>
  );
}
